export default {
	'Rechercher un fichier': 'Search file',
	selectedfiles: 'No files selected | {count} file selected | {count} files selected',
	titleselection: 'Your selection | Your selection, {count} file | Your selection, {count} files',
	results: {
		infos: 'No result | {count} file, <strong>see the result</strong> | {count} files, <strong>see the result</strong>'
	},
	'Adresse postales': 'Mail address',
	'Moins de 50 ans': 'Less than 50 years',
	filename: 'Keywords; senior, home',
	selectioninfo: "A summary of your selection will be sent with your request confirmation email. You will also find <a href='{link}' target='_blank'>a link to download</a> the pdf document of the selection.",
	fichier: {
		couplage: {
			asile: {
				range: 'From {min} to {max} g',
				beyond: 'Above %s g'
			}
		}
	},
	pagination: {
		title: 'See {count} additional files',
		subtitle: '{count} files displayed on {total}',
		total: 'No files available | {count} files available | {count} files available',
	},
	searchsite: {
		pagination: {
			total: '{count} result | {count} result | {count} results',
		}
	},
	'Votre sélection':'Your selection',
	'Inclure ma sélection avec ma demande':'Include my selection with my application',
	'Télécharger le pdf':'Download the pdf',
	'Consommation':'Consumption',
	'Réaction':'Reaction',
	'Activité':'Activity',
	"Mode d'achat":'Mode of purchase',
	"Ajouter à la sélection":"Add to selection",
	"Fichier ajouté à la sélection":"File added to selection",
	"Fichier retiré de la sélection":"File removed from selection",
	'Filtrez par univers':'Filter by universe',
	'Filtrez par canal':'Filter by channel',
	'Voir les filtres avancés': 'View advanced filters',
	'Votre adresse de contact': 'Your contact address',
	"Renseignez votre adresse email afin que nos équipes puissent vous conseiller !":"Enter your email address so that our teams can advise you!",
	"Votre adresse email":"Your email address",
	"En renseignant votre adresse email, vous acceptez d'être recontacté par ITL et vous reconnaissez avoir pris connaissance de notre politique de confidentialité.": 'By providing your email address, you agree to be contacted by ITL and acknowledge that you have read our privacy policy.',
	'Profils':'Profiles',
	'Sélections possibles':'Possible selections',
	'Âge moyen':'Average age',
	'ans':'Years',
	'Prix':'Price',
	'Délai':'Delay',
	'Données variables':'Variable data',
	'Nous consulter':'Consult us',
	'Déduplication':'Deduplication',
	'Frais informatiques':'Computer costs',
	'Frais de sélection':'Selection costs',
	'Au mille':'Per thousand',
	'Coût pour mille (CPM)':'Cost per thousand (CPM)',
	"Nous consulter pour plus d'informations.":'Consult us for more information.',
	'Commentaire':'Comment',
	'Commande moyenne':'Average order',
	'Potentiels':'Potentials',
	'Poids maximum':'Maximum weight',
	'Format maximum':'Maximum format',
	'Filtrer par univers': 'Filter by universe',
	'Inclure les fichiers présents dans les univers sélectionnés.': 'Include files present in selected universes.',
	'Femmes actives': 'Active women',
	'Santé beauté bio': 'Health beauty bio',
	'Maison loisir': 'Home leisure',
	'Santé senior': 'Senior health',
	'Vins gastronomie': 'Wines gastronomy',
	'Filtrer par canaux': 'Filter by channels',
	'Inclure les fichiers ayant les canaux sélectionnés.': 'Include files with selected channels.',
	'Adresses emails': 'Email addresses',
	'Adresses postales': 'Postal addresses',
	'Téléphones': 'Telephones',
	'Asile colis': 'Parcel asylum',
	'Asile-colis': 'Parcel asylum',
	'Encarts presse': 'Press inserts',
	'Copier la recherche': 'Copy the search',
	'Fermer la recherche': 'Close the search',
	'Comment pouvons  nous vous aider ? ': 'How can we help you? ',
	'Vous souhaitez en savoir plus - nous contacter': 'You want to know more - contact us',
	'Vous avez un projet - nous en parler': 'You have a project - talk to us about it',
	'Vous avez besoin de conseils ?  Discutez avec un de nos specialistes': 'Need advice?  Discuss with one of our specialists',
	'Votre message': 'Your message',
	'Ecrivez nous votre message': 'Write us your message',
	'qui êtes vous ': 'who are you',
	'Société': 'Company',
	'Prénom': 'First name',
	'Nom': 'Name',
	'E-mail': 'E-mail',
	'Téléphone': 'Phone',
	'envoyez ma demande': 'send my request',
	'Parler-nous de votre projet': 'Tell us about your project',
	'Informations complémentaires': 'Additional information',
	'Adresse': 'Address',
	'Ville': 'City',
	'Code postal': 'Postal code',
	'Réinitialiser': 'Reset',
	'Résultat de la recherche': 'Search result',
	'Effacer': 'Erase',
	'Potentiel': 'Potential',
	'Télécharger la sélection': 'Download the selection',
	'Boîte à outils': 'Toolbox',
	'Fermer':'Close',
	'Résultat':'Result',
	'Sélectionnez un outils pour commencer à calculer !':'Select a tool to start calculating!',
	"Taux de rendement":'Rate of return',
	"Estimez le taux de rendement de votre prochaine opération":'Estimate the rate of return on your next operation',
	"Estimez le coût d'acquisition d'un nouveau client suite à une opération de marketing direct":'Estimate the cost of acquiring a new customer following a direct marketing operation',
	'Remplissez les champs pour estimer le taux de rendement de votre prochaine opération':'Fill in the fields to estimate the return rate of your next operation',
	"Taille de l'échantillon testé":'Size of the test sample',
	'Taux de rendement sur cet échantillon (%)':'Rate of return on this sample (%)',
	"Remplissez les champs pour afficher votre intervalle de confiance.":'Fill in the fields to display your confidence interval.',
	"L'intervalle de confiance":'The confidence interval',
	"En marketing direct, il est nécessaire d'être prévoyant pour éviter toute erreur.":'In direct marketing, it is necessary to be forewarned to avoid any error.',
	"C'est pourquoi nous vous proposons de découvrir ci-dessous un outil de prévision très facile à utiliser pour vous permettre d'évaluer le taux de remontée de vos futures campagnes en fonction des résultats d'un test. Cet outil basé sur le tableau d'Otheiner, vous permet de déterminer l'intervalle de confiance, c'est-à-dire les limites basses et hautes dans lesquelles vous pourrez prévoir le rendement de votre action sur la globalité ou partie d'un fichier dont vous avez testé un échantillon au préalable.":'That is why we propose you to discover below a very easy to use forecasting tool to allow you to evaluate the return rate of your future campaigns based on the results of a test. This tool, based on the Otheiner table, allows you to determine the confidence interval, i.e., the lower and upper limits within which you can predict the return on your action on the whole or part of a file that you have previously tested a sample of.',
	"Source : d'après le tableau de R. Ostheiner de Time Inc. réalisé pour la DMA et les travaux de Pierre Boeglin dans l'utilisation de la loi de Gauss dans l'interprétation des tests.":"Source: based on the table by R. Ostheiner from Time Inc. made for the DMA and the work of Pierre Boeglin in the use of the Gaussian law in the interpretation of tests.",
	'La fiabilité des résultats du test dépend non pas de la taille du fichier testé mais de la taille de votre échantillon (qui ne doit être ni de taille trop réduite, ni trop importante, ce qui conduirait à des prises de risques inutiles).':'The reliability of the test results depends not on the size of the tested file but on the size of your sample (which should not be too small or too large, which would lead to unnecessary risks).',
	"Rendement":"Yield",
	"Exemple : Rendement 1,3 % sur 10 000 envois de messages, soit 130 réponses en moyenne.":'Example: Yield 1.3% on 10,000 message sends, or 130 responses on average.',
	"Coût d'acquisition":'Acquisition cost',
	"Calculez le cout d'acquisition d'un nouveau client suite à une opération de marketing direct":"Calculate the cost of acquiring a new customer following a direct marketing operation",
	"Coût de la campagne (€) *":'Cost of the campaign (€) *',
	"Nombre de nouveaux clients *":'Number of new customers *',
	"Coût total des produits (€) *":'Total cost of products (€) *',
	"Coût total du transport":'Total cost of transportation',
	"Coût total des cadeaux":'Total cost of gifts',
	"Chiffre d'affaire (€) *":'Turnover (€) *',
	"Remplissez les champs pour déterminer votre coût d'acquisition.":'Fill in the fields to determine your acquisition cost.',
	"Les clients recrutés ne vous ont":'The recruited customers have not cost you',
	"rien coûté":'anything',
	"Chaque nouveau client recruté vous a rapporté":'Each new recruited customer has brought you',
	"de marge":'margin',
	"Vous avez investi":'You have invested',
	"pour recruter un client":'to recruit a customer',
	"Minimum de location":'Minimum rental',
	'Aucun fichier disponible pour cette recherche':'No file available for this search',
	'Réinitialiser les filtres':'Reset filters',
	'Aucun résultat pour ces critères de recherche':'No results for this search',
	"Essayez avec d'autres paramètres":"Try with another filters",
}
